
import http from "@util/http.js";
let _domain = "lenovo.com.cn";
let _papiPrefix = "https://papi.";

if (document.location.href.toLocaleLowerCase().indexOf("localhost") != -1) {
    _domain = "lenovouat.com";
} else {
    const firstChildDomain = document.domain.indexOf(".");
    _domain = document.domain.substr(firstChildDomain + 1);
}

if (document.domain.toLocaleLowerCase().indexOf("lecoo.lenovouat.com") != -1) {
    _papiPrefix = 'https://papilecoo.';
}

export default {
    getCart() {
        return http.get('/napi/cart/getcart.jhtm');
    },
    removeItem(params) {
        return http.postFormData('/napi/cart/deleteitemfromcart.jhtm', params);
    },
    modifyCount(params) {
        return http.postFormData('/napi/cart/modifycartitemcount.jhtm', params);
    },
    addFavorite(params) {
        return http.jsonp(_papiPrefix + _domain + '/cache/myfavorites/addfavorites.do', "callback", "callback", params);
    },
    recommend(params) {
        // return http.get('/pp/batch/openapi/goods/recommend/mgetDetail/B00106', params);
        return http.jsonp(_papiPrefix + _domain + '/batch/openapi/goods/recommend/mgetDetail/B00106', "jsonpCallback", "jQueryJSONP_recommend_mgetDetail", params);
        // return http.jsonp('https://papi.lenovo.com.cn/batch/openapi/goods/recommend/mgetDetail/B00106', "jsonpCallback", "jQueryJSONP_recommend_mgetDetail", params);
    },
    goCheckout(params) {
        return http.postFormData('/napi/checkout/checkout.jhtm', params);
    },
    setActive(params) {
        return http.postFormData('/napi/cart/activeItem.jhtm', params);
    },
    getHasCoupons(params) {
        return http.postFormData('/couponnew/api/coupon/getCouponsByCart.jhtm', params);
    },
    getCouponList(params) {
        return http.get('/napi/cart/getCartItemCoupons.jhtm', params);
    },
    getCheckedCartItem(params) {
        return http.get('/napi/cart/checkedCartItem.jhtm', params);
    },
    getServiceList(params) {
        return http.jsonp(_papiPrefix + _domain + '/batch/openapi/goods/service/get/B00001?mode=2', "jsonpCallback", "jQueryJSONP_batch_get", params);
    },
    getServiceListInfo(params) {
        return http.jsonp(_papiPrefix + _domain + '/batch/openapi/goods/detail/get/B00001/wapdetail', "jsonpCallback", "jsonpCallback", params);
    },
    setCouponCheckedCartItem(params) {
        return http.postFormData('/napi/cart/checkedCartItem.jhtm', params);
    },
    getActiveList(params) {
        return http.jsonp('https://s.' + _domain + '/search/v2/searchJSONP?', "callback", "callback", params);
        // return http.get('/search/v2',params);
    },
    getGoToOrderFromCart(params) {
        return http.get('/napi/cart/goToOrderFromCart.jhtm', params);
    },
    getCouponGoToOrder(params) {
        return http.get('/napi/cart/couponGoToOrder.jhtm', params);
    },
    getActiveId(params) {
        return http.get('/api/cart/goToOrdedrFromCart', params);
    },
    bindCouponForOnce(params) {
        return http.get('/couponnew/api/coupon/neoBind.jhtm', params);
    },
    modifyItemFromCart(params) {
        return http.postFormData('/napi/cart/modifyItemFromCart.jhtm', params);
    },
    getSimilarityGoods(params) {
        return http.jsonp(_papiPrefix + _domain + '/batch/openapi/goods/recommend/mgetDetail/B00106', "jsonpCallback", "jQueryJSONP_recommend_mgetDetail", params);
    },
    getOptionsAndGifts(params) {
        return http.jsonp(_papiPrefix + _domain + '/api/promotions', "callback", "jQueryJSONP_promotions", params,);
    },
    addGoodsToCard(params) {
        return http.postFormData('/napi/cart/additemtocart.jhtm', params);
    },
    //根据商品编码获取私人定制商品信息
    getPersonalGoods(params) {
        return http.jsonp(_papiPrefix + _domain + '/batch/openapi/goods/personal/position', "jsonpCallback", "jQueryJSONP_batch_get", params);
    },
    //根据商品编码获取私人定制商品信息
    getPersonalPictures(params) {
        return http.jsonp(_papiPrefix + _domain + '/batch/openapi/goods/personal/category/pic', "jsonpCallback", "jQueryJSONP_cache_query", params);
    },
    //获取/设置默认配送地址
    getDefaultAddressData(params) {
        //return http.get('/dispatchAddr.jhtm', params);
        return http.get('/useraddr/dispatchAddr.jhtm', params);
        // return http.jsonp("https://buy."+_domain+'/dispatchAddr.jhtm',"jsonpCallback","jQueryJSONP_cache_query",params);
    },
    //获取省份数据
    getProvinceAddressData(params) {
        //return http.get('/getprovince.jhtm', params);
        return http.get('/region/getprovince.jhtm', params);
    },
    //获取市级数据
    getCityAddressData(params) {
        //return http.get('/getcities.jhtm', params);
        return http.get('/region/getcities.jhtm', params);
    },
    //获取区级数据
    getAreaAddressData(params) {
        //return http.get('/getcounties.jhtm', params);
        return http.get('/region/getcounties.jhtm', params);
    },
    //获取街道/镇级数据
    getSubdistrictAddressData(params) {
      return http.get('/region/getvillages.jhtm', params);
    },
    //获取用户收货地址数据
    getUserAddressList(params) {
        //return http.get('/consignee/getList.jhtm', params);
        return http.get('/useraddr/getList.jhtm', params);
    },
    // 购物车C面刻字风控
    riskCheck(params) {
        return http.jsonp('https://i.' + _domain + '/risk/textReview.jhtml', "callback", "JSONP_risk_check", params);
    },
    //获取私定刻字emoji
    getPersonalCarveEmojis(params) {
        return http.jsonp(_papiPrefix + _domain + '/openapi/common.emotions.getCEmoji', "callback", "emojis", params);
    },
    //获得官方喷绘效果图
    getPersonalPrint(params) {
        return http.jsonp('https://open.' + _domain + '/goods/personal/print', "jsonpCallback", "getPrint", params);
    },
}